/// ///////////////////////////////////////////////////////////////////////////////
// Copyright (C) 2026 CONQUER INNOVATIONS SP. Z O.O. Global B.V. and its affiliate(s).
// All rights reserved.
//
// This software and other materials contain proprietary information
// controlled by CONQUER INNOVATIONS SP. Z O.O. and are protected by applicable copyright legislation.
// Any use and utilization of this software and other materials and
// disclosure to any third parties is conditional upon having a separate
// agreement with CONQUER INNOVATIONS SP. Z O.O. for the access, use, utilization or disclosure of this
// software. In the absence of such agreement, the use of the software is not
// allowed.
// The creator, author and originator of the code in the current file: Michał Pawłowski
//////////////////////////////////////////////////////////////////////////////////
<template>
  <b-modal
      v-model="visible"
      title=""
      size="xl"
      hide-footer
  >
    <CommonTableImportForm
        title="Import danych Aptek"
        importType="drugstores"
        mode="submit"
        :fieldDefinitions="fields"
        @onSaved="handleSuccess"
    />
  </b-modal>
</template>

<script>

import CommonTableImportForm from "@/components/widgets/CommonTableImportForm.vue";

export default {
  name: "DrugstoresListImportWrapper",
  components: {CommonTableImportForm},
  data() {
    return {
      visible: false, // Sterowanie modalem z zewnątrz przez ref lub v-model

      // Definicja pól zgodna z DrugstoreDto (uproszczona)
      fields: [
        {key: "drugstoreClientId", label: "Kamsoft ID", required: true, type: "string"},
        {key: "name", label: "Nazwa apteki", required: false, type: "string"},
        {key: "address", label: "Adres", required: false, type: "string"},
        {key: "zipcode", label: "Kod pocztowy", required: false, type: "string"},
        {key: "city", label: "Miasto", required: false, type: "string"},
        {key: "nip", label: "NIP", required: false, type: "string"},
        {key: "phoneNumber", label: "Telefon", required: false, type: "string"},
        {key: "email", label: "E-mail", required: false, type: "string"},
        {key: "companyName", label: "Nazwa firmy", required: false, type: "string"},
        {key: "companyAddress", label: "Adres firmy", required: false, type: "string"},
        {key: "accountNumber", label: "Numer konta bankowego", required: false, type: "string"},
        {key: "bankName", label: "Nazwa banku", required: false, type: "string"},

      ]
    };
  },
  methods: {
    open() {
      this.visible = true;
    },
    handleSuccess(response) {
      this.visible = false;
      this.$emit('refresh-list'); // Odśwież listę pod spodem
    }
  }
};
</script>